import React from 'react';
import { Link } from 'gatsby';

const Start = () => (
	<div style={{ display: 'flex' }}>
		<section className="services">
			<img src={require(`../images/lanside.png`)} className="lanside" alt="Building" />
			<p style={{ fontSize: '2rem' }}>
				<strong>How to get started.</strong>
			</p>

			<p>
				Maybe you're a home owner and you're looking to convert your garage to a guest room, extend a wall out a
				few feet, or do a big kitchen remodel. Or maybe you're ready to build your dream home from the ground
				up. If you're not sure where to start, the process can be a little intimidating.
			</p>

			<p>
				Construction costs can have dramatic fluctuations in price based on several factors. Even moving a
				bathroom wall out a foot can be as inexpensive as a few thousand dollars or as much as tens of
				thousands. General Contractors tend to be skittish about quoting bids without seeing actual plans with
				all the variables and details mapped out.
			</p>

			<p>
				At this point, you need to pick a designer. The type of designer will depend on the project size. For
				remodels where no exterior walls are being moved, you will probably only need an Interior Designer. Such
				individuals will help the owner chose paints, drapes, tiles, appliances, etc. If exterior walls must be
				moved or built, you'll need a Draftsman or an Architect.
			</p>

			<p>
				Generally, an Architect oversees all phases of construction. They work with interior designers, the
				builders, the Engineers, virtually everyone involved in the construction projects. Although the services
				they provide are invaluable to help manage the complexity of high budget, large scale commercial
				buildings, many home owners tend to save money by doing much of the management themselves. As such, they
				might see a Draftsman who typically only designs the house plans and does minor consulting with
				builders.
			</p>

			<p>
				If you decide to go the route of hiring a Draftsman, there's a few things you'll want to keep in mind. A
				good Draftsman will work with the owner to ensure the plans he or she drafts will both reflect what the
				owner wants as well as what the owner can afford. Since General Contractors often will not give bids on
				projects until the plans are finished, it's important that you find a Draftsman who you trust to
				accurately give you a design that will result in a construction cost within your budget.
			</p>

			<p>
				Most Draftsmen should be available at their offices to meet with home owners and discuss plans free of
				charge. Once the basic ideas of the project are laid out by both parties, the Draftsman should give the
				owners a quote on the cost of the plans. The owner may wish to visit multiple Draftsmen until they find
				one they're comfortable with.
			</p>

			<p>
				For more information on what is included on a set of plans, click{' '}
				<Link style={{ color: 'blue' }} to="/plans">
					here
				</Link>.
			</p>
		</section>
	</div>
);

export default Start;
